import axios from 'axios';
import util from './util.js';

let baseUrl = '//wx.beijinghome.cc/';
// let baseUrl = '//test.jcfyht.cc/';

let request = function (options, isHideLoading = false) {
  options = Object.assign({
    method: 'GET',
    timeout: 20000,
  }, options);
  options.url = baseUrl + options.url;
  if (options.method == 'GET') {
    options.url += "?" + util.stringify(options.data)
    delete options.data
  } else {
    options.data = util.stringify(options.data)
  }
  isHideLoading ? '' : util.showLoading();
  return axios(options)
    .then(function (res) { // 服务器状态判断
      isHideLoading ? '' : util.hideLoading();
      if (res.status == 200) {
        return res.data;
      } else {
        util.showToast("网络异常，请稍后重试");
      }
    })
}

let request_file = function (options, isHideLoading = false) {
  options = Object.assign({
    method: 'GET',
    timeout: 20000,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }, options);
  options.url = baseUrl + options.url;

  if (options.method == 'GET') {
    options.url += "?" + util.stringify(options.data)
    delete options.data
  } else {
    options.data = util.stringify(options.data)
  }
  isHideLoading ? '' : util.showLoading();
  return axios(options)
    .then(function (res) { // 服务器状态判断
      isHideLoading ? '' : util.hideLoading();
      if (res.status == 200) {
        return res.data;
      } else {
        util.showToast("网络异常，请稍后重试");
      }
    })
}





//公告请求底层
let appranking = (options, isHideLoading) => {
  console.log(options)
  options.data = Object.assign({}, options.data, {
    api_name: options.url,
    login_id: util.getLocalStorage('userid')
  });
  options.url = 'Contract/api/capi';
  return request(options, isHideLoading);
}

let my_block = (options, isHideLoading) => {
  options.data = Object.assign({}, options.data, {
    api_name: options.url,
    token: 'clientjcfy'
  });
  options.url = 'Contract/api/capi';
  return request(options, isHideLoading);
}

let my_block_file = (options, isHideLoading) => {
  options.data = Object.assign({}, options.data, {
    api_name: options.url,
    token: 'clientjcfy'
  });
  options.url = 'Contract/api/capi?api_name=uploadsfz&pic_type=sfzzm&token=clientjcfy&gzhid=' +
    util.getLocalStorage("openid");
  return request_file(options, isHideLoading);
}


let contract = (options, isHideLoading) => {
  let table_type = '';
  if (location.href.indexOf('/liangshu/') != -1) {
    table_type = 'liangshu'
  }
  options.data = Object.assign({}, options.data, {
    api_name: options.url,
    table_type: table_type
  });
  options.url = 'Contract/api/fangwu.do';
  return request(options, isHideLoading);
}


let rankingActions = {
  getAppRanking(data) {
    console.log(data);
    // 添加任务
    return appranking({
      url: 'cms_info',
      method: "GET",
      data
    })
  },
  //注册
  registered_active(data) {
    return my_block({
      url: 'zhuce',
      method: "GET",
      data
    })
  },
  //获得用户信息
  getuser_info(data) {
    return my_block({
      url: 'getuserinfo',
      method: "POST",
      data
    })
  },
    //获得认证url
  getRZUrl(data) {
    return my_block({
      url: 'getcainfo',
      method: "POST",
      data
    })
  },
  //用户实名认证
  user_RZ(data) {
    return my_block({
      url: 'renzheng',
      method: "POST",
      data
    })
  },
  //刷脸实名认证
  user_RLRZ(data) {
    return my_block({
      url: 'shualian',
      method: "POST",
      data
    })
  },
  //待签约接口(订单接口)
  contract_DQ(data) {
    return my_block({
      url: 'daiqianyue',
      method: "POST",
      data
    })
  },
  //已签约接口
  contract_YQ(data) {
    return my_block({
      url: 'yiqianyue',
      method: "POST",
      data
    })
  },
  //查看合同附件接口
  contract_FJ(data) {
    return my_block({
      url: 'view_rw_file',
      method: "POST",
      data
    })
  }
}

//我的模块
let my_block_active = {
  get_content_list(data) {
    return my_block({
      url: 'mycontract',
      method: "POST",
      data
    })
  },
  get_browse_list(data) {
    return my_block({
      url: 'xf_list',
      method: "POST",
      data
    })
  },
  //注册
  registered_active(data) {
    return my_block({
      url: 'zhuce',
      method: "GET",
      data
    })
  },
  //获得用户信息
  getuser_info(data) {
    return my_block({
      url: 'getuserinfo',
      method: "POST",
      data
    })
  },
  //用户实名认证
  user_RZ(data) {
    return my_block({
      url: 'renzheng',
      method: "POST",
      data
    })
  },
  //待签约接口
  contract_DQ(data) {
    return my_block({
      url: 'daiqianyue',
      method: "POST",
      data
    })
  },
  //已签约接口
  contract_YQ(data) {
    return my_block({
      url: 'yiqianyue',
      method: "POST",
      data
    })
  },
  //查看合同附件接口
  contract_FJ(data) {
    return my_block({
      url: 'view_rw_file',
      method: "POST",
      data
    })
  },
  //上传文件
  upload_file_sfz(data) {
    return my_block_file({
      data
    })
  },
  //实名认证校验手机号
  phone_validation(data) {
    return my_block({
      url: 'ssq_get_yzm',
      method: "POST",
      data
    })
  },
  //验证码
  phone_validation_shiming(data) {
    return my_block({
      url: 'ssq_send_yzm',
      method: "POST",
      data
    })
  },
  //推出登录
  login_out(data) {
    return my_block({
      url: 'tuichu',
      method: "POST",
      data
    })
  },
  //登录
  login_in(data){
    return my_block({
      url: 'denglu',
      method: "POST",
      data
    })
  }

}

let contractActions = {
  getHtParams(data) {
    return contract({
      url: 'api_ht_col',
      method: "POST",
      data
    })
  },
  commitHt(data, isHideLoading) {
    return contract({
      url: 'api_save_ht',
      method: "POST",
      data
    }, isHideLoading)
  },
  getHtList(data) {
    return contract({
      url: 'api_ht_view_info',
      method: "POST",
      data
    })
  },
  publishHt(data) {
    return contract({
      url: 'ht_submit',
      method: "POST",
      data
    })
  },
  getUserInfoById(data, isHideLoading) {
    return contract({
      url: 'api_get_userinfo',
      method: "POST",
      data
    }, isHideLoading)
  },
  getHtDx(data) {
    return contract({
      url: 'api_ht_dx',
      method: "POST",
      data
    })
  },
  cancleHt(data) {
    return contract({
      url: 'api_chexiao_ht',
      method: "POST",
      data
    })
  },
  lockHt(data) {
    return contract({
      url: 'api_suoding',
      method: "POST",
      data
    })
  },
  isLockHt(data) {
    return contract({
      url: 'api_check_suoding',
      method: "POST",
      data
    })
  },
  uploadHtImage(data) {
    return contract({
      url: 'api_ht_pic',
      method: "POST",
      data
    })
  },
  getHtImages(data) {
    return contract({
      url: 'api_ht_viewpic',
      method: "POST",
      data
    })
  },
  deleteHtImage(data) {
    return contract({
      url: 'api_ht_delpic',
      method: "POST",
      data
    })
  },
  unLockHt(data) {
    return contract({
      url: 'cancel_ht',
      method: "POST",
      data
    })
  },
  getHtProgress(data) {
    return contract({
      url: 'view_ht_jd',
      method: "POST",
      data
    })
  },
  perfectHt(data) {
    return contract({
      url: 'api_ht_bc',
      method: "POST",
      data
    })
  },
  getYezhuInfo(data) {
    return contract({
      url: 'api_get_yzinfo',
      method: "POST",
      data
    })
  },
  contract_pic(data) {
    return service({
      url: 'contract_pic',
      method: "POST",
      data
    })
  }
}



let actions = {
  ...rankingActions,
  ...my_block_active,
  ...contractActions
};

export default actions;
